import React from 'react';
import { Link } from 'react-router-dom';

const CategoryHero = ({ category }) => {
  if (!category) {
    return null;
  }

  // Function to get background image URL from category data
  const getBackgroundImage = () => {
    if (!category.BackgroundImage) return null;

    // Handle Strapi v4 structure (nested in data.attributes)
    const imageData = category.BackgroundImage?.data?.attributes || category.BackgroundImage;
    
    // Get the URL
    let imageUrl = imageData?.url;
    
    if (!imageUrl) return null;

    // If URL is relative, prepend Strapi URL
    if (imageUrl.startsWith('/')) {
      const strapiUrl = process.env.REACT_APP_STRAPI_URL || 'http://localhost:1337';
      imageUrl = `${strapiUrl}${imageUrl}`;
    }

    return imageUrl;
  };

  const backgroundImage = getBackgroundImage();

  // Dynamic background style
  const backgroundStyle = backgroundImage
    ? {
        backgroundImage: `linear-gradient(rgba(30, 64, 175, 0.85), rgba(30, 64, 175, 0.55)), url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }
    : {};

  // Dynamic section classes
  const sectionClasses = backgroundImage
    ? 'py-20'
    : 'bg-gradient-to-br from-catalina-blue to-san-marino py-20';

  return (
    <section className={sectionClasses} style={backgroundStyle}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Breadcrumb */}
        <nav className="mb-8">
          <ol className="flex items-center space-x-2 text-sm text-white/80">
            <li>
              <Link to="/" className="hover:text-white transition duration-300">
                Home
              </Link>
            </li>
            <li>
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
              </svg>
            </li>
            <li>
              <Link to="/products" className="hover:text-white transition duration-300">
                Products
              </Link>
            </li>
            <li>
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
              </svg>
            </li>
            <li className="text-white font-medium">
              {category.Name}
            </li>
          </ol>
        </nav>

        {/* Hero Content */}
        <div className="text-center text-white">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            {category.Name}
          </h1>
          <p className="text-xl md:text-2xl text-white/90 max-w-3xl mx-auto leading-relaxed">
            {category.Description || 'Explore our comprehensive range of products in this category'}
          </p>
        </div>
      </div>
    </section>
  );
};

export default CategoryHero;